// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--WBBjd"};